import {Component, Input, OnInit, ViewEncapsulation} from '@angular/core';
import {RouterModule} from '@angular/router';
import {CommonModule, NgOptimizedImage} from '@angular/common';

import {NgbCarouselConfig, NgbCarouselModule,} from '@ng-bootstrap/ng-bootstrap';
import {ListingMedia} from '../../../core/models/listing';

@Component({
  standalone: true,
  imports: [
    CommonModule,
    NgbCarouselModule,
    RouterModule,
    CommonModule,
    NgbCarouselModule,
    NgOptimizedImage,
  ],
  selector: 'app-ngbd-carousel-config',
  templateUrl: 'carousel-config.html',
  styleUrls: ['./carousel-config.css'],
  providers: [NgbCarouselConfig], // add NgbCarouselConfig to the component providers
  encapsulation: ViewEncapsulation.None

})
export class NgbdCarouselConfigComponent implements OnInit {
  @Input() imageArr!: ListingMedia[];
  @Input() addressHyphenStr!: string;
  @Input() cityHyphenStr!: string
  @Input() MLSNum!: string;
  images = [700, 533, 807, 124].map((n) => `https://picsum.photos/id/${n}/900/500`);

  constructor(config: NgbCarouselConfig) {
    // customize default values of carousels used by this component tree
    config.interval = 5000;
    config.wrap = true;
    config.keyboard = false;
    config.pauseOnHover = false;

  }

  ngOnInit(): void {

    // console.log(this.imageArr);
    // console.log('hello world');
  }

  replaceImage(obj: { _elementObj: any; }) {
    // define properties
    const elementObj = obj._elementObj;

    // console.log(elementObj);
  }

  normalizeImageUrl(originalUrl: string): string {
    if (!originalUrl) return '';
    return originalUrl
      .replace('fit-in/5000x5000', 'fit-in/1200x1200')
      .replace('800x800', '1200x1200');
  }


}
